const firebaseConfig = {
    apiKey: "AIzaSyDEncZMp9tCU9PKY7s6VU9vH0ff2FL28OE",
    authDomain: "corify--automotive-center.firebaseapp.com",
    projectId: "corify--automotive-center",
    storageBucket: "corify--automotive-center.appspot.com",
    messagingSenderId: "509289619864",
    appId: "1:509289619864:web:09fd538b422f0f87274bed"
};
export default firebaseConfig